window.hidePdpSlide = (() => {
  'use strict';

  const applyHide = (productId, slideIndices) => {
    const mainSlider = document.getElementById(`productMainSlider-${productId}`);
    const thumbSlider = document.getElementById(`productThumbSlider-${productId}`);

    if (!mainSlider) return;

    const mainSlides = mainSlider.querySelectorAll(
      `#productMainSlider-${productId} > .js-carousel-slider > .js-carousel-slide`
    );

    slideIndices.forEach((index) => {
      if (mainSlides[index]) mainSlides[index].style.display = 'none';
    });

    mainSlider.initPages();

    if (!thumbSlider) return;

    const thumbSlides = thumbSlider.querySelectorAll(
      `#productThumbSlider-${productId} > .js-carousel-slider > .js-carousel-slide`
    );

    slideIndices.forEach((index) => {
      if (thumbSlides[index]) thumbSlides[index].style.display = 'none';
    });

    let newIndex = 0;
    thumbSlides.forEach((slide) => {
      if (slide.style.display !== 'none') {
        slide.setAttribute('data-slide-index', newIndex++);
      }
    });

    thumbSlider.initPages();
  };

  const init = (productId, slideIndices = [1]) => {
    if (!productId) return;
    const indices = Array.isArray(slideIndices) ? slideIndices : [slideIndices];
    const mainSlider = document.getElementById(`productMainSlider-${productId}`);
    if (!mainSlider) return;

    if (mainSlider.sliderItems) {
      applyHide(productId, indices);
    } else {
      mainSlider.addEventListener('carousel:updated', () => applyHide(productId, indices), { once: true });
    }
  };

  return { init };
})();
